import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import 'moment/locale/es';
import Modal from 'react-responsive-modal';
import LiveCameraViewer from './LiveCameraViewer';

moment.locale('es');

const EventIntrusionList = ({ eventIntrusions = [] }) => {
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedBuildingId, setSelectedBuildingId] = useState(null);
  const [selectedCameraId, setSelectedCameraId] = useState(null);
  const [selectedCameraName, setSelectedCameraName] = useState(null);

  const openImagesModal = (imageUrls, buildingId, cameraId, cameraName) => {
    setImages(imageUrls);
    setSelectedBuildingId(buildingId);
    setSelectedCameraId(cameraId);
    setSelectedCameraName(cameraName);
    setShowImagesModal(true);
  };

  const closeImagesModal = () => {
    setShowImagesModal(false);
    setImages([]);
    setSelectedBuildingId(null);
    setSelectedCameraId(null);
    setSelectedCameraName(null);
  };

  const sortedEvents = eventIntrusions.slice().sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

  return (
    <>
      <div className="mt-3 p-0 table-users">
        <table className="table table-striped">
          <thead className="text-center font-weight-bold">
            <tr>
              <th scope="col">Cámara</th>
              <th scope="col">Hora Inicio</th>
              <th scope="col">Hora Fin</th>
              <th scope="col">Edificio</th>
              <th scope="col">Vista multimedia</th>
            </tr>
          </thead>
          <tbody>
            {sortedEvents.length > 0 ? (
              sortedEvents.map((event) => {
                const { id, cameraId, cameraName, startTime, endTime, imageUrls, buildingId, buildingName } = event;

                return (
                  <tr key={id}>
                    <td data-label="Cámara" className="align-middle">
                      {cameraName}
                    </td>
                    <td data-label="Hora Inicio" className="align-middle">
                      {moment(startTime).format('D MMM YYYY h:mm A')}
                    </td>
                    <td data-label="Hora Fin" className="align-middle">
                      {moment(endTime).format('D MMM YYYY h:mm A')}
                    </td>
                    <td data-label="Edificio" className="align-middle">
                      {buildingName}
                    </td>
                    <td data-label="Detalles" className="align-middle">
                      <span
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => openImagesModal(imageUrls, buildingId, cameraId, cameraName)}
                      >
                        Ver secuencia y video en vivo
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No hay eventos de intrusión disponibles.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal open={showImagesModal} classNames={{ overlay: 'background-modal' }} onClose={closeImagesModal} center>
        <div
          style={{
            maxWidth: '100vw',
            maxHeight: '80vh',
            padding: 10,
            overflow: 'hidden',
          }}
        >
          {images.length > 0 && (
            <div style={{ display: 'flex', overflowX: 'auto', gap: 10 }}>
              {images.map((imgUrl, i) => (
                <img
                  key={i}
                  src={imgUrl}
                  alt={`Imagen ${i + 1}`}
                  style={{ height: 200, borderRadius: 10, flexShrink: 0 }}
                />
              ))}
            </div>
          )}

          {selectedBuildingId && selectedCameraId && (
            <div style={{ background: 'white', borderRadius: '10' }}>
              <LiveCameraViewer
                buildingId={selectedBuildingId}
                door={{
                  cameras: [{ id: selectedCameraId, name: selectedCameraName }],
                }}
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

EventIntrusionList.propTypes = {
  eventIntrusions: PropTypes.array,
};

export default EventIntrusionList;
